module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTKqqqqmpqaqqqqqqqq+vr6qqqqqqqqqqqvLl8vkAAAAIdFJOUwBfoIgwEPDPCZpEDwAAAFxJREFUGNNjYIABCwM4k4GpownBsejoUIBz3Do6mmFsU5aMjg6YjvYAt45GKEejo5QlQwBmVEd7gCNcoqOjFG4HEDQiSXQI0FbCAkmCAVmCAVmCAVmCAVmCAVkCAAcUMak84XxkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/profile-edit.png
// module id = 1120
// module chunks = 0